import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IPublicKeys } from 'src/interfaces/publickKeys';
import { enqueueRequestErrorSnackbar } from '../actions/enqueueSnackbar';
import { CommonState, error, isFetching } from './common';

const name = 'public-keys';

export const fetchPublicKeys = createAsyncThunk(`${name}/fetch`, async (_, { dispatch }) => {
  try {
    const {
      data: { publicKeys }
    } = await axios.get<{ publicKeys: IPublicKeys }>('/spapi/serverTokens');

    return publicKeys;
  } catch (error) {
    dispatch(enqueueRequestErrorSnackbar());
    throw error;
  }
});

export type State = CommonState & {
  publicKeys: IPublicKeys | null;
};

const initialState: State = {
  isFetching: false,
  publicKeys: null,
  error: null
};

const publicKeys = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchPublicKeys.pending, isFetching)
      .addCase(fetchPublicKeys.rejected, error)
      .addCase(fetchPublicKeys.fulfilled, (state, action) => {
        state.publicKeys = action.payload;
        state.isFetching = false;
      });
  }
});

export const { reducer: publicKeysReducer } = publicKeys;
